import { render, staticRenderFns } from "./user-interface-4-notification-list.vue?vue&type=template&id=0bb9a701&scoped=true&"
import script from "./user-interface-4-notification-list.vue?vue&type=script&lang=ts&"
export * from "./user-interface-4-notification-list.vue?vue&type=script&lang=ts&"
import style0 from "./user-interface-4-notification-list.vue?vue&type=style&index=0&id=0bb9a701&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9a701",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VIcon,VSnackbar})
